export const MSGS = {
  CHANGE_PASSWORD_SUCCESS: "Password updated successfully",
  PROFILE_UPDATE_SUCCESS: "Updated successfully",
};

export default MSGS;
